export const InventorySvg = ({ props, active }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 13.3c-.13 0-.26-.03-.38-.1L2.79 8.09a.752.752 0 01-.27-1.03.75.75 0 011.03-.27L12 11.68l8.4-4.86a.76.76 0 011.03.27c.21.36.08.82-.27 1.03l-8.77 5.08a.94.94 0 01-.39.1z"
        fill={active ? '#FF6A00' : '#fff'}
      />
      <path
        d="M12 22.36c-.41 0-.75-.34-.75-.75v-9.07c0-.41.34-.75.75-.75s.75.34.75.75v9.07c0 .41-.34.75-.75.75z"
        fill={active ? '#FF6A00' : '#fff'}
      />
      <path
        d="M12 22.75c-.88 0-1.75-.19-2.44-.57l-5.34-2.97c-1.45-.8-2.58-2.73-2.58-4.39V9.17c0-1.66 1.13-3.58 2.58-4.39l5.34-2.96c1.37-.76 3.51-.76 4.88 0l5.34 2.97c1.45.8 2.58 2.73 2.58 4.39v5.65c0 1.66-1.13 3.58-2.58 4.39l-5.34 2.96c-.69.38-1.56.57-2.44.57zm0-20c-.63 0-1.25.13-1.71.38L4.95 6.1c-.96.54-1.81 1.97-1.81 3.08v5.65c0 1.1.85 2.54 1.81 3.08l5.34 2.97c.91.51 2.51.51 3.42 0l5.34-2.97c.96-.54 1.81-1.97 1.81-3.08V9.18c0-1.1-.85-2.54-1.81-3.08l-5.34-2.97c-.46-.25-1.08-.38-1.71-.38z"
        fill={active ? '#FF6A00' : '#fff'}
      />
      <path
        d="M17.001 13.99c-.41 0-.75-.34-.75-.75v-3.22l-9.12-5.26a.742.742 0 01-.27-1.02.74.74 0 011.02-.27l9.49 5.48c.23.13.38.38.38.65v3.66c0 .39-.34.73-.75.73z"
        fill={active ? '#FF6A00' : '#fff'}
      />
    </svg>
  );
};
